import type {
  CreateMemberGroupRequest,
  UpdateMemberGroupRequest
} from '@library/types/memberGroups';
import { useCallback, useContext } from 'react';
import {
  useCreateMemberGroupMutation,
  useUpdateMemberGroupMutation
} from '@bo-services/members/memberGroupsApi';
import { CreateEditMemberGroupModal } from '@bo-components/memberGroups/CreateEditMemberGroupModal';
import { MemberGroupsContext } from '@bo-hooks/memberGroups/useMemberGroupsContext';

export function MemberGroupsModals() {
  const { currentModal, modalMemberGroup, closeModal } =
    useContext(MemberGroupsContext);
  const [createMemberGroup] = useCreateMemberGroupMutation();
  const [updateMemberGroup] = useUpdateMemberGroupMutation();

  const onCreateSave = useCallback(
    async (memberGroup: CreateMemberGroupRequest) => {
      await createMemberGroup(memberGroup);
      closeModal();
    },
    [closeModal, createMemberGroup]
  );

  const onEditSave = useCallback(
    async (memberGroup: UpdateMemberGroupRequest) => {
      await updateMemberGroup(memberGroup);
      closeModal();
    },
    [closeModal, updateMemberGroup]
  );

  return (
    <CreateEditMemberGroupModal
      memberGroup={modalMemberGroup}
      isOpen={currentModal === 'create' || currentModal === 'edit'}
      onCancelModal={closeModal}
      onSaveCreate={onCreateSave}
      onSaveEdit={onEditSave}
    />
  );
}
